export class AdvertisingManager {

	modelManager
	connectionManager

	lastIdx = 0

	/**
	 * TODO Modularize this class more
	 * - Dynamic campaign words
	 * - Model manager handles word cache
	 * - Dynamic endpoints etc
	 */

		//Image api key
	API_KEY = "669727790aabbef873b02a50caab8034767cd5639f102adcee873ab93090106f"

	//TODO move to registration function and out of core SDK
	//Key = detected word, value = campaign id
	campaignWords = {
		"pizza": "pizza",
		"dominos": "dominos",
		"domino's": "dominos",
		"drink": "coke",
		"coke": "coke",
		"pepsi": "pepsi",
		"mcdonald's": "mcdonalds",
		"nuggets": "nuggets",
		"burger": "burger",
		"chicken": "kfc",
		"kfc": "kfc",
		"coffee": "starbucks",
		"starbucks": "starbucks",
		"VC": "lavender",
		"venture": "lavender",
		"capital": "lavender",
		"lavender": "lavender",
		"roseon": "roseon",
		"frozen": "roseon",
		"roseum": "roseon",
		"roseanne": "roseon",
		"parisian": "roseon",
		"rosie": "roseon",
		"daomaker": "daomaker",
		"dollmaker": "daomaker",
		"maker": "daomaker",
		"cdfi": "seedify",
		"cedar": "seedify",
		"sida": "seedify",
		"cedar fire": "seedify",
		"seedify": "seedify",
		"alpha": "alphabatem",
		"alphabatem": "alphabatem",
	}

	//Used to cache recent results (campaign_id -> image_url)
	//We have temporarily added some local assets as preloads - //TODO move to registration function and out of core SDK
	wordCache = {
		"pizza": {images_results: [{original: "/assets/adverts/images/pizza.jpg"}]},
		"dominos": {images_results: [{original: "/assets/adverts/images/dominos.jpg"}]},
		"coke": {images_results: [{original: "/assets/adverts/images/coke.jpg"}]},
		"pepsi": {images_results: [{original: "/assets/adverts/images/pepsi.jpg"}]},
		"mcdonalds": {images_results: [{original: "/assets/adverts/images/mcdonalds.jpg"}]},
		"nuggets": {images_results: [{original: "/assets/adverts/images/nuggets.jpg"}]},
		"burger": {images_results: [{original: "/assets/adverts/images/burger.jpg"}]},
		"kfc": {images_results: [{original: "/assets/adverts/images/kfc.jpg"}]},
		"starbucks": {images_results: [{original: "/assets/adverts/images/starbucks.jpg"}]},
		"roseon": {images_results: [{original: "/assets/adverts/images/roseon.jpg"}]},
		"lavender": {images_results: [{original: "/assets/adverts/images/lavender_capital.jpg"}]},
		"daomaker": {images_results: [{original: "/assets/adverts/images/daomaker.jpg"}]},
		"seedify": {images_results: [{original: "/assets/adverts/images/seedify.jpg"}]},
		"alphabatem": {images_results: [{original: "/assets/adverts/images/alphabatem.png"}]},
	}

	constructor(modelManager, connectionManager) {
		this.modelManager = modelManager;
		this.connectionManager = connectionManager;
	}

	handleAdvertTrigger(image) {
		//STUB
	}

	/**
	 * Accepts a remote advert (in the form o player_animation) and returns a local advert
	 * @param animation_id
	 */
	addRemoteAdvert(animation_id) {
		console.log("Adding remote advert: " + animation_id);

		const animKey = Object.keys(this.campaignWords)[animation_id]
		const word = this.campaignWords[animKey];

		if (!this.wordCache[word]) {
			console.log("Skipping remote advert, missing cache: ", word)
			return;
		}

		const resp = this.wordCache[this.campaignWords[word]]
		if (resp.images_results.length > 0) {
			console.log("Adding result: ", resp.images_results[0].original);
			this.handleAdvertTrigger(resp.images_results[0].original)
		}
	}


	/**
	 * Checks through a array of words and triggers advertising on any matched campaign words
	 *
	 * @param words
	 */
	checkForDetectedWords(words) {
		console.log(`${this.lastIdx} Checking for detected words in: `, words);

		let si = this.lastIdx

		for (let i = si; i < words.length; i++) {
			const lword = words[i].toLowerCase();
			if (this.campaignWords[lword]) {
				this.lastIdx = i + 1;
				this.handleDetectedWord(lword)
			}
		}
	}

	reset() {
		this.lastIdx = 0;
	}

	/**
	 * Handles a detected word
	 *
	 * @param word
	 */
	handleDetectedWord(word) {
		console.log("Handling detection: ", word)

		this.connectionManager.wsLocalAdvert(Object.keys(this.campaignWords).indexOf(this.campaignWords[word]))

		if (this.wordCache[this.campaignWords[word]]) {
			console.log("Word already in cache")

			// const resp = this.wordCache[this.campaignWords[word]]
			// if (resp.images_results.length > 0) {
			// 	console.log("Adding result: ", resp.images_results[0].original);
			//
			// 	this.handleAdvertTrigger(resp.images_results[0].original) //Add to local billboard
			// }

			return;
		}

		//Not in cache
		//Load then display
		console.log("Cache miss, loading")
		this.loadCampaignImage(word)
	}

	loadCampaignImage(word) {
		const data = null;
		const xhr = new XMLHttpRequest();
		// xhr.withCredentials = true;

		xhr.addEventListener("readystatechange", () => {
			if (this.readyState === this.DONE) {
				const resp = JSON.parse(this.responseText)
				console.log(resp);

				this.wordCache[word] = resp;

				if (resp.images_results.length > 0) {
					console.log("Adding result: ", resp.images_results[0].original);
					// this.advertQueue.push(resp.images_results[0].original)
					this.handleAdvertTrigger(resp.images_results[0].original) //Add to local billboard
				}
			}
		});

		xhr.open("GET", `//serpapi.com/search?tbm=isch&q=${word}&num=5&api_key=${this.API_KEY}`);
		xhr.send(data);
	}

	reset() {
		this.lastIdx = 0;
	}
}